import DestinationIndex from "@/views/directory/destination/DestinationIndex.vue";

const destination = [
    {
        path: '/destinations',
        name: 'destination',
        component: DestinationIndex
    }
]

export default destination;